<template>
  <div class="sp_sangforLogo">
    <div class="sp_logo_top"
         :class="{active:activeIndex==3}">
      <img src="@a/img/sangfor.png"
           alt="SANGFOR">
      <div class="active-three"
           v-if="activeIndex == 3">
        <span class="line"></span>
        <h3>Sangfor Support Portal</h3>
      </div>
    </div>
    <!-- <div v-if="activeIndex !== 1 && page !== 'forgotPassword' && activeIndex !== 3"
         class="sp_logo_bottom">
      <h3>Sangfor Support Portal</h3>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'sangforLogo',
  props: {
    activeIndex: {
      type: Number,
      required: false,
    },
    page: {
      type: String,
      default: "",

    }
  },

}
</script>

<style lang="scss" scoped>
.sp_sangforLogo {
  width: 100%;
  .active {
    margin-bottom: 20px !important;
  }
  .sp_logo_top {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin-bottom: 80px;
    img {
      width: 135px;
    }
    .active-three {
      font-size: 16px;
      font-weight: 500;
      color: #13161a;
      display: flex;
      align-items: center;
      .line {
        width: 1px;
        height: 19px;
        background-color: #e1e6ed;
        display: inline-block;
        margin: 0 17px;
      }
      h3 {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .sp_logo_bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    img {
      width: 52px;
    }
    h3 {
      text-align: center;
      width: 100%;
      color: #13161a;
      font-size: 24px;
      font-weight: 500;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 33px;
    }
  }
}
</style>